import { render, staticRenderFns } from "./ComplainIcon.vue?vue&type=template&id=ebe93df6&"
import script from "./ComplainIcon.vue?vue&type=script&lang=js&"
export * from "./ComplainIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports